import React, { Component } from 'react';
import * as Styled from './styled';
import { isLinesUsedInDates } from '../../../helpers/experiments';

interface Props {
  onSelect: (any) => void;
  isDisabled: boolean;
  isToday: boolean;
  isSelected: boolean;
  date: {
    dateStr: string;
    day: string;
    id: number;
    isPrev?: boolean;
    isNext?: boolean;
  };
  daysTimes?: any;
}

interface State {
  daysTimesVisible: boolean;
}

class CalendarDay extends Component<Props, State> {
  hasManyTimes: boolean;

  get daysTimes() {
    return this.props.daysTimes.get(this.props.date.dateStr);
  }

  handleClick = () => {
    const { isDisabled, onSelect } = this.props;

    if (isDisabled) return;

    onSelect(this.daysTimes);
  };

  render() {
    const { date, isDisabled, isToday, isSelected } = this.props;

    const dateHasTickets = this.daysTimes
      ? Boolean(this.daysTimes.filter((date) => date.has_tickets).length)
      : false;

    return (
      <Styled.CalendarDay
        isToday={isToday}
        isSelected={isSelected}
        isDisabled={isDisabled}
        onClick={this.handleClick}
        isPrev={date.isPrev}
        isNext={date.isNext}
        isLines={isLinesUsedInDates()}
      >
        {date.day}
        {!isDisabled && (
          <>{dateHasTickets ? <Styled.HasTicketsDate /> : <Styled.NoTicketsDate />}</>
        )}
      </Styled.CalendarDay>
    );
  }
}

export default CalendarDay;
